// extracted by mini-css-extract-plugin
export default {"select":"SelectInput_select__EaoVX"};